"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformUtil = void 0;

var _flow = _interopRequireDefault(require("lodash/flow"));

var _fromPairs = _interopRequireDefault(require("lodash/fromPairs"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _pick = _interopRequireDefault(require("lodash/pick"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _isObject = _interopRequireDefault(require("lodash/isObject"));

var _map = _interopRequireDefault(require("lodash/map"));

var _toPairs = _interopRequireDefault(require("lodash/toPairs"));

var _normalizr = require("normalizr");

var _stringUtils = require("@eb/string-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * @param {string} key Key to fetch
 * @param {object} fieldsNameMap Object to fetch key from
 */
var _getKey = function _getKey(key, fieldsNameMap) {
  var newKey = key;

  if (fieldsNameMap[key]) {
    newKey = fieldsNameMap[key];
  }

  return (0, _stringUtils.snakeToCamel)(newKey);
};
/**
 * Get a value from a given set of fields
 * @param {*} value
 * @param {*} fields
 * @param {*} fieldsNameMap
 * @param {boolean} isWhiteList
 */


var _getValue = function _getValue(value, fields, fieldsNameMap, isWhiteList) {
  var newValue = value;

  if ((0, _isObject.default)(value) && !(0, _isArray.default)(value)) {
    /*eslint-disable no-use-before-define*/
    newValue = _nestedObjectHelper(value, fields, fieldsNameMap, isWhiteList);
  } else if ((0, _isArray.default)(value)) {
    newValue = value.map(function (v) {
      return _getValue(v, fields, fieldsNameMap, isWhiteList);
    });
  }

  return newValue;
};
/**
 * Pick or omit keys from an object
 * @param {object} obj
 * @param {string[]} fields
 * @param {boolean} isWhiteList
 */


var _selectKeysFromResponseObject = function _selectKeysFromResponseObject(obj, fields, isWhiteList) {
  if ((0, _isEmpty.default)(fields)) {
    return obj;
  }

  var method = isWhiteList ? 'pick' : 'omit';
  var methods = {
    pick: _pick.default,
    omit: _omit.default
  };
  var prunedObj = methods[method](obj, fields);
  return prunedObj;
};
/**
 * Recursively traverses the passed in object turning each key to camelCase and will
 * exclude/include any key located in the fields
 * @param {object} obj
 * @param {string[]} fields
 * @param {object} fieldsNameMap
 * @param {boolean} isWhiteList
 */


var _nestedObjectHelper = function _nestedObjectHelper(obj, fields, fieldsNameMap, isWhiteList) {
  var prunedObj = _selectKeysFromResponseObject(obj, fields, isWhiteList);

  var fn = (0, _flow.default)(_toPairs.default, _map.default, function (kvps) {
    return kvps.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          val = _ref2[1];

      return [_getKey(key, fieldsNameMap), _getValue(val, fields, fieldsNameMap, isWhiteList)];
    });
  }, _fromPairs.default);
  return fn(prunedObj);
};
/**
 * Determines if a key should bge removed
 * @param {boolean} isWhiteList
 * @param {string} key
 * @param {object[]} fields
 */


var _shouldRemoveKey = function _shouldRemoveKey(isWhiteList, key, fields) {
  var isKeyInFields = fields.indexOf(key) > -1;
  return isWhiteList && !isKeyInFields || !isWhiteList && isKeyInFields;
};
/**
 * This function is a default behavior that defaults the assignEntity process for the
 * main normalize function call.
 *
 * The key processes it allows are:
 *     1. transition of snake_case to camelCase for variables at any depth in the response object.
 *     2. removal/inclusion of any keys listed in fields at any depth in the response object.
 *
 *
 * If you do not want this function to be called at all simply send null as the parameter value.
 *
 * If you need extra functionality beyond what this provides you are welcome to write your own, examples on
 * the API and usage cases can be found at the normalizr repo: https://github.com/paularmstrong/normalizr
 *
 * @param {object} obj The transformed response value being built as input is being stepped over by the normalize function
 * @param {string} key The current key of the input object being iterated over
 * @param {any} val The value of the current key at the input object
 * @param {object[]} fields check param of transformUtil
 * @param {object} fieldsNameMap check param of transformUtil
 * @param {object} isWhiteList check param of transformUtil
 */


var _defaultFunc = function _defaultFunc(obj, key, val, fields, fieldsNameMap, isWhiteList) {
  /* Because of the way normalizr handles arrays it is necessary to do a key by key check here */
  if (!(0, _isEmpty.default)(fields) && _shouldRemoveKey(isWhiteList, key, fields)) {
    return;
  }
  /* This is required to match the functionality of the assignEntity function provided by normalizr */

  /*eslint-disable no-param-reassign*/


  obj[_getKey(key, fieldsNameMap)] = _getValue(val, fields, fieldsNameMap, isWhiteList);
};
/**
 * A transformUtil for receiving responses from the backend that modifies the objects into
 * maps by ID, and many other useful features as detailed on the normalizr repo (link).
 *
 * This wrapper is provided that adds the functionality change all keys from snake_case to camelCase
 * and remove any unwanted fields from the response.
 *
 * The only required fields are the response and the schema object, which is created in the standard
 * normalizr fasion. Supports overwriting the default assignEntity function if you wish extra
 * custom behavior.
 * @param {object} options
 * @param {object} options.response jSON Object which is the API response
 * @param {object} options.schema The normalizr Schema object that you would like to apply to the response object
 * @param {object} [options.options] The options block that will be passed to the normalize call. Will be merged with default options so any overwriting is possible.
 * @param {object[]} [options.fields] Array of key values to either white list or black list from the normalized object
 *                 IMPORTANT: For whitelisted parameters you must include the entire path to the key
 *                 you want to keep. The normalize function operates one depth at a time
 * @param {object} [options.fieldsNameMap] Object in where the `key` will be renamed with the name of the `value`
 * @param {boolean} [options.isWhiteList] - Boolean determining whether to whitelist or blacklist the keys in `fields` param.
 */


var transformUtil = function transformUtil(_ref3) {
  var response = _ref3.response,
      schema = _ref3.schema,
      _ref3$options = _ref3.options,
      options = _ref3$options === void 0 ? {} : _ref3$options,
      _ref3$fields = _ref3.fields,
      fields = _ref3$fields === void 0 ? [] : _ref3$fields,
      _ref3$fieldsNameMap = _ref3.fieldsNameMap,
      fieldsNameMap = _ref3$fieldsNameMap === void 0 ? {} : _ref3$fieldsNameMap,
      _ref3$isWhiteList = _ref3.isWhiteList,
      isWhiteList = _ref3$isWhiteList === void 0 ? false : _ref3$isWhiteList;
  var normalizedResponse;

  if (schema) {
    var defaultOptions = {
      assignEntity: function assignEntity(obj, key, val) {
        _defaultFunc(obj, key, val, fields, fieldsNameMap, isWhiteList);
      }
    };
    normalizedResponse = (0, _normalizr.normalize)(response, schema, _objectSpread({}, defaultOptions, {}, options));
  }

  return normalizedResponse;
};

exports.transformUtil = transformUtil;
//# sourceMappingURL=transformUtil.js.map